import React from "react";
import "./App.scss";
import About from "./components/About/About";
import Contract from "./components/Contract/Contract";
import Footer from "./components/Footer/Footer";
import Gurus from "./components/Gurus/Gurus";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import Projects from "./components/Projects/Projects";
import Skills from "./components/Skills/Skills";
import Sidebar from "./components/Sidebar/Sidebar";
import { useState } from "react";
import TopButton from "./components/TopButton";

const App = () => {
    const [isOpenSidebar, setIsOpenSidebar] = useState(false);
    

    const sidebarHandler = () => {
        setIsOpenSidebar(!isOpenSidebar);
    };
    return (
        <div className="App">
           
            <TopButton />
            <Header sidebarHandler={sidebarHandler} />
            <Sidebar
                isOpenSidebar={isOpenSidebar}
                sidebarHandler={sidebarHandler}
            />
            <Home />
            <About />
            <Skills />
            <Projects />
            <Gurus />
            <Contract />
            <Footer />
        </div>
    );
};

export default App;
